import React, { useState, useContext, useEffect } from "react";

import { Container, Grid, Checkbox } from "@material-ui/core";

import Icon from "@material-ui/core/Icon";

import Card from "../../../../components/cards/Card";
import TextField from "../../../../components/basics/TextFieldErp";
import Chip from "../../../../components/basics/Chip";
import Btn from "../../../../components/buttons/Btn";
import Fieldset from "../../../../components/basics/Fieldset";
import SearchDialog from "../../../../patterns/modals/SearchDialog";

import { EmissaoContext } from "../contexts/EmissaoContext";
import useEmissaoController from "../controllers/EmissaoController";

import AddIcon from "@material-ui/icons/Add";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";

import { Header, Body, Padding } from "../styles/Emissao";
import ModalEmissaoEndEntrega from "./ModalEmissaoEndEntrega";
import SearchSelect from "../../../../components/inputs/SearchSelect";
import ModalEmissaoCadastroCliente from "./ModalEmissaoCadastroCliente";
import Select from "../../../../components/basics/SelectErp";
import { MinClienteContext } from "../contexts/MinClienteContext";
import Swal from "sweetalert2";
import SelectErp from "../../../../components/basics/SelectErp";

const AccordionEmissaoRemetente = ({ ...props }) => {
  const {
    nfeError,
    senderName,
    senderCnpj,
    setSenderCnpj,
    senderAddress,
    setSenderAddres,
    senderDistrict,
    setSenderDistrict,
    senderCity,
    setSenderCity,
    senderUfLabel,
    setSenderUfLabel,
    senderCep,
    setSenderCep,
    senderPhone,
    setSenderPhone,
    senderMail,
    setSenderMail,
    senderCheckBilling,
    senderBillingAddress,
    setSenderBillingAddress,
    senderBillingDistrict,
    setSenderBillingDistrict,
    senderBillingCity,
    setSenderBillingCity,
    senderBillingUf,
    setSenderBillingUf,
    senderBillingCep,
    setSenderBillingCep,
    senderBillingComplement,
    setSenderBillingComplement,
    senderCheckDelivery,
    setSenderCheckDelivery,
    senderDeliveryAddress,
    setSenderDeliveryAddress,
    senderDeliveryDistrict,
    setSenderDeliveryDistrict,
    senderDeliveryCity,
    setSenderDeliveryCity,
    senderDeliveryUf,
    setSenderDeliveryUf,
    senderDeliveryCep,
    setSenderDeliveryCep,
    senderDeliveryComplement,
    setSenderDeliveryComplement,
    senderClifor,
    sender,
    setSender,
    senderListIndicationIe,
    senderIndicationIe,
    setSenderIndicationIe,
    senderIe,
    setSenderIe,
    setUpdateSender,
    listCounty,
    listUf,
    loadingInputs,
    senderNumber,
    setSenderNumber,
    senderBillingNumber,
    setSenderBillingNumber,
    senderDeliveryNumber,
    setSenderDeliveryNumber,
    senderComplement,
    senderRuralEstablishmentsList,
    senderRuralEstablishment,
    setSenderRuralEstablishment,
    isRuralProducerSender,
  } = useContext(EmissaoContext);

  const { generalIe, generalIeIndication } = useContext(MinClienteContext);

  const {
    handleSelectClient,
    handleTypeNfe,
    handleCheckCobranca,
    handleSelectProvider,
    setEnableDeliveryEdit,
    setEnableBillingEdit,
    enableEndereco,
    enableBillingEdit,
    enableDeliveryEdit,
    handleChangeCep,
    createPaymentItem,
    handleSenderRuralEstablishmentSelection,
    clearClient,
  } = useEmissaoController();

  const [modalEndEntregaOpen, setModalEndEntregaOpen] = useState(false);
  const [modalClienteOpen, setModalClienteOpen] = useState(false);
  const [modalFornecedorOpen, setModalFornecedorOpen] = useState(false);
  const [modalMinClienteCadastroOpen, setModalMinClienteCadastroOpen] =
    useState(false);

  // eslint-disable-next-line
  const [exapandedDelivery, setExpandedDelivery] = useState(true);
  const [optionReciever, setOptionReciever] = useState(null);

  const listOptionsReceiver = [
    { label: "Cliente", value: "C" },
    { label: "Fornecedor", value: "F" },
  ];

  const columnsClienteSearch = [
    { label: "CÓD.", id: "id" },
    { label: "Nome", id: "apelido", align: "center", style: { minWidth: 400 } },
    {
      label: "Fantasia",
      id: "razao",
      align: "center",
      style: { minWidth: 400 },
    },
    {
      label: "CNPJ/CPF",
      id: "cpfcnpj",
      align: "center",
      style: { minWidth: 200 },
    },
    { label: "Telefone", id: "telefone1" },
    {
      label: "Cidade",
      id: "cidade",
      align: "center",
      style: { minWidth: 200 },
    },
    { label: "CEP", id: "cep", align: "center", style: { minWidth: 150 } },
  ];

  const columnsFornecedorSearch = [
    { label: "CÓD.", id: "id" },
    { label: "Nome", id: "razao", align: "center", style: { minWidth: 400 } },
    {
      label: "Endereco",
      id: "endereco",
      align: "center",
      style: { minWidth: 200 },
    },
    {
      label: "Bairro",
      id: "bairro",
      align: "center",
      style: { minWidth: 200 },
    },
    {
      label: "Cidade",
      id: "cidade",
      align: "center",
      style: { minWidth: 200 },
    },
    { label: "Cep", id: "cep", align: "center", style: { minWidth: 150 } },
  ];

  useEffect(() => {
    if (sender?.id) {
      if (senderClifor === "C" && sender.alerta_faturamento) {
        Swal.fire({
          icon: "warning",
          text: `Alerta de Faturamento: ${sender.alerta_faturamento}`,
          showCloseButton: true,
        });
      }
    }
  }, [sender, senderClifor]);

  useEffect(() => {
    if (sender?.id) {
      if (senderClifor === "C") {
        handleSelectClient(() => {}, [sender]);
      } else {
        handleSelectProvider(() => {}, [sender]);
      }
    }
    // eslint-disable-next-line
  }, [sender, senderClifor]);

  useEffect(() => {
    if (
      (generalIeIndication &&
        senderIndicationIe &&
        generalIeIndication.codigo !== senderIndicationIe.codigo &&
        senderClifor === "C") ||
      (senderIe !== generalIe && senderClifor === "C")
    ) {
      setUpdateSender(true);
    } else {
      setUpdateSender(false);
    }
  }, [
    generalIeIndication,
    senderIndicationIe,
    senderIe,
    generalIe,
    senderClifor,
    setUpdateSender,
  ]);

  useEffect(() => {
    if (senderIndicationIe?.codigo === "2") {
      setSenderIe("");
    }
  }, [senderIndicationIe, setSenderIe]);

  useEffect(() => {
    setOptionReciever(
      senderClifor === "C"
        ? { label: "Cliente", value: "C" }
        : { label: "Fornecedor", value: "F" }
    );
  }, [senderClifor, setOptionReciever]);

  return (
    <>
      {modalMinClienteCadastroOpen && (
        <ModalEmissaoCadastroCliente
          open={modalMinClienteCadastroOpen}
          setOpen={setModalMinClienteCadastroOpen}
        />
      )}
      {modalClienteOpen && (
        <SearchDialog
          open={modalClienteOpen}
          setOpen={setModalClienteOpen}
          columns={columnsClienteSearch}
          selectable={true}
          multiSelect={false}
          handleMainClick={handleSelectClient}
          route="prouser/clientes/v1"
          include="clientesentregas,contasbancarias,municipio.estado,transportadora.estado,estabelecimentosRurais,estabelecimentosRurais.endereco,estabelecimentosRurais.contatos,estabelecimentosRurais.endereco.municipio,estabelecimentosRurais.endereco.estado"
          filter="razao,apelido,id,cep,cpfcnpj,telefone1"
          title="CLIENTES"
          where={{ ativo: "S" }}
        />
      )}
      {modalFornecedorOpen && (
        <SearchDialog
          open={modalFornecedorOpen}
          setOpen={setModalFornecedorOpen}
          columns={columnsFornecedorSearch}
          selectable={true}
          multiSelect={false}
          handleMainClick={handleSelectProvider}
          route="prouser/fornecedores/v1"
          include="estado,estabelecimentosRurais,estabelecimentosRurais.endereco,estabelecimentosRurais.contatos,estabelecimentosRurais.endereco.municipio,estabelecimentosRurais.endereco.estado"
          title="FORNECEDORES"
          filter="razao,id"
          where={{ ativo: "S" }}
        />
      )}
      {modalEndEntregaOpen && (
        <ModalEmissaoEndEntrega
          modalEndEntregaOpen={modalEndEntregaOpen}
          setModalEndEntregaOpen={setModalEndEntregaOpen}
        />
      )}
      <Fieldset
        titulo={
          <Header>
            <Grid container spacing={2}>
              <Grid item lg={5} sm={3} alignItems="center" container>
                <Chip
                  bgcolor={
                    nfeError.accordions &&
                    nfeError.accordions.includes("sender")
                      ? "red"
                      : ""
                  }
                  textcolor={
                    nfeError.accordions &&
                    nfeError.accordions.includes("sender")
                      ? "white"
                      : ""
                  }
                  label="DESTINATÁRIO"
                />
              </Grid>
              <Grid item lg={5} sm={6}>
                <TextField
                  label={senderClifor === "C" ? "Cliente" : "Fornecedor"}
                  variant="filled"
                  size="small"
                  value={senderName}
                  error={nfeError.senderName ? true : false}
                  helperText={nfeError.senderName || ""}
                  disabled
                />
              </Grid>
              <Grid item lg={2} sm={3}>
                <TextField
                  label="CPF/CNPJ"
                  variant="filled"
                  size="small"
                  value={senderCnpj}
                  disabled
                />
              </Grid>
            </Grid>
          </Header>
        }
        bgcolor="white"
        textcolor="black"
        defaultExpanded={false}
        accordion
      >
        <Container maxWidth="xl">
          <Body>
            <Grid container spacing={4}>
              <Grid item sm={6}>
                <Card line="left" lineColor="primary">
                  <Grid container spacing={2}>
                    <Grid
                      item
                      sm={12}
                      justifyContent="center"
                      alignItems="center"
                      container
                    >
                      <Grid item sm={3}>
                        <Select
                          value={optionReciever}
                          setValue={setOptionReciever}
                          optionsList={listOptionsReceiver}
                          descriptionField="label"
                          label="Tipo Destinatário"
                          onChange={(e) => handleTypeNfe(e, true)}
                          disabledSearchByText
                        />
                      </Grid>
                      <Grid item sm={9}>
                        <Chip
                          label={
                            senderName
                              ? senderName
                              : senderClifor === "C"
                              ? "CLIENTE"
                              : "FORNECEDOR"
                          }
                          bgcolor="secondary"
                        />
                      </Grid>
                    </Grid>
                    <Grid item sm>
                      {senderClifor === "C" ? (
                        <SearchSelect
                          getOptionLabel={(option) =>
                            option?.cpfcnpj && option?.razao
                              ? `${option?.cpfcnpj} - ${option?.razao}`
                              : `${option?.cpfcnpj || ""}${option?.razao || ""}`
                          }
                          variant="filled"
                          value={sender}
                          onChange={(value) => {
                            setSender(value);
                            if (!value) {
                              clearClient();
                            }
                          }}
                          label="Razão"
                          route="prouser/clientes/v1"
                          include="clientesentregas,contasbancarias,municipio.estado,transportadora.estado,estabelecimentosRurais,estabelecimentosRurais.endereco,estabelecimentosRurais.contatos,estabelecimentosRurais.endereco.municipio,estabelecimentosRurais.endereco.estado"
                          filter="razao,apelido,id"
                          where={{ ativo: "S" }}
                        />
                      ) : (
                        <SearchSelect
                          descriptionField="razao"
                          variant="filled"
                          value={sender}
                          onChange={(value) => {
                            setSender(value);
                            if (!value) {
                              clearClient();
                            }
                          }}
                          label="Razão"
                          include="estado,estabelecimentosRurais,estabelecimentosRurais.endereco,estabelecimentosRurais.contatos,estabelecimentosRurais.endereco.municipio,estabelecimentosRurais.endereco.estado"
                          route="prouser/fornecedores/v1"
                          filter="razao,id"
                          where={{ ativo: "S" }}
                        />
                      )}
                    </Grid>
                    <Grid item>
                      {senderClifor === "C" ? (
                        <Btn
                          label={<Icon> search</Icon>}
                          full="true"
                          onClick={() => setModalClienteOpen(true)}
                        />
                      ) : (
                        <Btn
                          label={<Icon> search</Icon>}
                          full="true"
                          onClick={() => setModalFornecedorOpen(true)}
                        />
                      )}
                    </Grid>
                    {senderClifor === "C" && (
                      <Grid item>
                        <Btn
                          bgcolor="lightgreen"
                          hovercolor="blue"
                          startIcon={<AddIcon />}
                          label={<AccountCircleIcon />}
                          full="true"
                          onClick={() => setModalMinClienteCadastroOpen(true)}
                        />
                      </Grid>
                    )}
                  </Grid>
                  <Padding padding={15}>
                    <Grid container spacing={2}>
                      <Grid item sm={12}>
                        <TextField
                          value={senderCnpj}
                          setValue={setSenderCnpj}
                          label="CPF/CNPJ"
                          size="small"
                        />
                      </Grid>
                      <Grid item sm={10}>
                        <TextField
                          value={
                            senderComplement
                              ? `${senderAddress} - ${senderComplement}`
                              : senderAddress
                          }
                          setValue={setSenderAddres}
                          label="Endereço"
                          size="small"
                          disabled
                          error={nfeError.senderAddress ? true : false}
                          helperText={nfeError.senderAddress || ""}
                        />
                      </Grid>
                      <Grid item sm={2}>
                        <TextField
                          value={senderNumber}
                          setValue={setSenderNumber}
                          label="Nro"
                          size="small"
                          disabled
                          error={nfeError.senderNumber ? true : false}
                          helperText={nfeError.senderNumber || ""}
                        />
                      </Grid>
                      <Grid item lg={6} sm={12}>
                        <TextField
                          value={senderDistrict}
                          setValue={setSenderDistrict}
                          label="Bairro"
                          size="small"
                          disabled
                        />
                      </Grid>
                      <Grid item lg={4} sm={9}>
                        <TextField
                          value={senderCity}
                          setValue={setSenderCity}
                          label="Cidade"
                          size="small"
                          error={nfeError.senderCity ? true : false}
                          helperText={nfeError.senderCity || ""}
                          disabled
                        />
                      </Grid>
                      <Grid item lg={2} sm={3}>
                        <TextField
                          value={senderUfLabel}
                          setValue={setSenderUfLabel}
                          label="Estado"
                          size="small"
                          error={nfeError.senderUfLabel ? true : false}
                          helperText={nfeError.senderUfLabel || ""}
                          disabled
                        />
                      </Grid>
                      <Grid item sm={6}>
                        <TextField
                          value={senderCep}
                          setValue={setSenderCep}
                          label="CEP"
                          size="small"
                          disabled
                        />
                      </Grid>
                      <Grid item sm={6}>
                        <TextField
                          value={senderPhone}
                          setValue={setSenderPhone}
                          label="Telefone"
                          size="small"
                          disabled
                        />
                      </Grid>
                      <Grid item sm={12}>
                        <TextField
                          value={senderMail}
                          setValue={setSenderMail}
                          label="Email"
                          size="small"
                          disabled
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Select
                          label="Indicação de IE"
                          value={senderIndicationIe}
                          setValue={setSenderIndicationIe}
                          optionsList={senderListIndicationIe}
                          descriptionField="label"
                          error={nfeError.senderIndicationIe ? true : false}
                          helperText={nfeError.senderIndicationIe || ""}
                        />
                      </Grid>
                      {senderIndicationIe?.codigo !== "2" ? (
                        <Grid item sm={12}>
                          <TextField
                            value={senderIe}
                            setValue={setSenderIe}
                            label="IE"
                            size="small"
                            error={nfeError.senderIe ? true : false}
                            helperText={nfeError.senderIe || ""}
                          />
                        </Grid>
                      ) : (
                        <></>
                      )}
                    </Grid>
                  </Padding>
                </Card>
              </Grid>
              <Grid item sm={6}>
                <Grid item lg={12}>
                  <Fieldset
                    titulo={
                      <Grid container spacing={2}>
                        <Grid item sm={1}>
                          <Checkbox
                            name="checkCobranca"
                            color="primary"
                            checked={senderCheckBilling}
                            onChange={handleCheckCobranca}
                            disabled={!enableEndereco}
                            onClick={(event) => event.stopPropagation()}
                            onFocus={(event) => event.stopPropagation()}
                          />
                        </Grid>
                        <Grid item sm>
                          <Chip
                            label="ENDEREÇO DE COBRANÇA"
                            bgcolor="secondary"
                          />
                        </Grid>
                        <Grid item>
                          <Btn
                            onClick={(event) => {
                              event.stopPropagation();
                              setEnableBillingEdit((current) => !current);
                            }}
                            disabled={!senderCheckBilling}
                            label={<Icon>edit</Icon>}
                            bgcolor="tertiary"
                            hovercolor="blue"
                            full="true"
                          />
                        </Grid>
                      </Grid>
                    }
                    bgcolor="white"
                    textcolor="black"
                    defaultExpanded={false}
                    accordion
                  >
                    <Grid container spacing={2}>
                      <Grid item lg={4} sm={3}>
                        <TextField
                          value={senderBillingCep}
                          setValue={setSenderBillingCep}
                          label="CEP"
                          size="small"
                          disabled={!enableBillingEdit}
                          onChange={(value) =>
                            handleChangeCep(value, "billing")
                          }
                        />
                      </Grid>
                      <Grid item lg={10} sm={10}>
                        <TextField
                          value={senderBillingAddress}
                          setValue={setSenderBillingAddress}
                          label="Endereço"
                          size="small"
                          disabled={!enableBillingEdit}
                          error={nfeError.senderBillingAddress ? true : false}
                          helperText={nfeError.senderBillingAddress || ""}
                        />
                      </Grid>
                      <Grid item lg={2} sm={2}>
                        <TextField
                          value={senderBillingNumber}
                          setValue={setSenderBillingNumber}
                          label="Nro"
                          size="small"
                          disabled={!enableBillingEdit}
                          error={nfeError.senderBillingNumber ? true : false}
                          helperText={nfeError.senderBillingNumber || ""}
                        />
                      </Grid>
                      <Grid item lg={6} sm={12}>
                        <TextField
                          value={senderBillingDistrict}
                          setValue={setSenderBillingDistrict}
                          label="Bairro"
                          size="small"
                          disabled={!enableBillingEdit}
                        />
                      </Grid>
                      <Grid item lg={2} sm={3}>
                        <Select
                          loading={loadingInputs.listUf || false}
                          optionsList={listUf}
                          value={senderBillingUf}
                          setValue={setSenderBillingUf}
                          descriptionField="estado"
                          label="Estado"
                          size="small"
                          disabled={!enableBillingEdit}
                          error={nfeError.senderBillingUf ? true : false}
                          helperText={nfeError.senderBillingUf || ""}
                        />
                      </Grid>
                      <Grid item lg={4} sm={9}>
                        <Select
                          loading={loadingInputs.listCounty || false}
                          value={senderBillingCity}
                          setValue={setSenderBillingCity}
                          descriptionField="municipio"
                          label="Cidade"
                          size="small"
                          disabled={!enableBillingEdit}
                          error={nfeError.senderBillingCity ? true : false}
                          helperText={nfeError.senderBillingCity || ""}
                          optionsList={
                            senderBillingUf
                              ? listCounty.filter(
                                  (opt) =>
                                    opt.estado_codigo ===
                                    senderBillingUf.codibge
                                )
                              : []
                          }
                        />
                      </Grid>
                      <Grid item lg={8} sm={9}>
                        <TextField
                          value={senderBillingComplement}
                          setValue={setSenderBillingComplement}
                          label="Complemento"
                          size="small"
                          disabled={!enableBillingEdit}
                        />
                      </Grid>
                    </Grid>
                  </Fieldset>
                </Grid>
                <Grid item lg={12}>
                  <Fieldset
                    titulo={
                      <Grid container spacing={2}>
                        <Grid item xs={1}>
                          <Checkbox
                            checked={senderCheckDelivery}
                            onChange={() =>
                              setSenderCheckDelivery((current) => !current)
                            }
                            disabled={!enableEndereco}
                            name="checkEntrega"
                            color="primary"
                            onClick={(event) => event.stopPropagation()}
                            onFocus={(event) => event.stopPropagation()}
                          />
                        </Grid>
                        <Grid item xs>
                          <Chip
                            label="ENDEREÇO DE ENTREGA"
                            bgcolor="secondary"
                          />
                        </Grid>
                        <Grid item>
                          <Btn
                            label={<Icon>edit</Icon>}
                            bgcolor="tertiary"
                            hovercolor="blue"
                            full="true"
                            onClick={(event) => {
                              event.stopPropagation();
                              setEnableDeliveryEdit((current) => !current);
                            }}
                            disabled={!senderCheckDelivery}
                          />
                        </Grid>
                        <Grid item>
                          <Btn
                            label={<Icon>search</Icon>}
                            onClick={(event) => {
                              event.stopPropagation();
                              setModalEndEntregaOpen(true);
                            }}
                            disabled={!senderCheckDelivery}
                            full="true"
                          />
                        </Grid>
                      </Grid>
                    }
                    bgcolor="white"
                    textcolor="black"
                    defaultExpanded={exapandedDelivery}
                    accordion
                  >
                    <Grid container spacing={2}>
                      <Grid item sm={12}>
                        <Chip
                          label="Deve ser preenchido caso o
                                mesmo seja diferente do Endereço Principal."
                        />
                      </Grid>
                      <Grid item sm={4} lg={4}>
                        <TextField
                          value={senderDeliveryCep}
                          setValue={setSenderDeliveryCep}
                          label="CEP"
                          size="small"
                          disabled={!enableDeliveryEdit}
                          onChange={(value) =>
                            handleChangeCep(value, "delivery")
                          }
                        />
                      </Grid>
                      <Grid item sm={10}>
                        <TextField
                          value={senderDeliveryAddress}
                          setValue={setSenderDeliveryAddress}
                          label="Endereço"
                          size="small"
                          disabled={!enableDeliveryEdit}
                          error={nfeError.senderDeliveryAddress ? true : false}
                          helperText={nfeError.senderDeliveryAddress || ""}
                        />
                      </Grid>
                      <Grid item sm={2}>
                        <TextField
                          value={senderDeliveryNumber}
                          setValue={setSenderDeliveryNumber}
                          label="Nro"
                          size="small"
                          disabled={!enableDeliveryEdit}
                          error={nfeError.senderDeliveryNumber ? true : false}
                          helperText={nfeError.senderDeliveryNumber || ""}
                        />
                      </Grid>
                      <Grid item sm={12} lg={6}>
                        <TextField
                          value={senderDeliveryDistrict}
                          setValue={setSenderDeliveryDistrict}
                          label="Bairro"
                          size="small"
                          disabled={!enableDeliveryEdit}
                        />
                      </Grid>
                      <Grid item sm={3} lg={2}>
                        <Select
                          optionsList={listUf}
                          value={senderDeliveryUf}
                          setValue={setSenderDeliveryUf}
                          label="Estado"
                          descriptionField="estado"
                          size="small"
                          disabled={!enableDeliveryEdit}
                          error={nfeError.senderDeliveryUf ? true : false}
                          helperText={nfeError.senderDeliveryUf || ""}
                        />
                      </Grid>
                      <Grid item sm={9} lg={4}>
                        <Select
                          value={senderDeliveryCity}
                          setValue={setSenderDeliveryCity}
                          descriptionField="municipio"
                          label="Cidade"
                          size="small"
                          disabled={!enableDeliveryEdit}
                          error={nfeError.senderDeliveryCity ? true : false}
                          helperText={nfeError.senderDeliveryCity || ""}
                          optionsList={
                            senderDeliveryUf
                              ? listCounty.filter(
                                  (opt) =>
                                    opt.estado_codigo ===
                                    senderDeliveryUf.codibge
                                )
                              : []
                          }
                        />
                      </Grid>
                      <Grid item sm={8} lg={8}>
                        <TextField
                          value={senderDeliveryComplement}
                          setValue={setSenderDeliveryComplement}
                          label="Complemento"
                          size="small"
                          disabled={!enableDeliveryEdit}
                        />
                      </Grid>
                    </Grid>
                  </Fieldset>
                </Grid>
                {isRuralProducerSender && (
                  <Grid item lg={12}>
                    <Card>
                      <Grid container spacing={2}>
                        <Grid
                          item
                          sm
                          style={{ alignItems: "center", display: "flex" }}
                        >
                          <Chip
                            label="ESTABELECIMENTO RURAL"
                            bgcolor="secondary"
                          />
                        </Grid>
                        <Grid item md={12}>
                          <SelectErp
                            disableClearable={true}
                            getOptionLabel={(option) =>
                              `${option.inscricao_estadual || "-"} - ${
                                option.descricao || "-"
                              }`
                            }
                            variant="filled"
                            optionsList={senderRuralEstablishmentsList}
                            value={senderRuralEstablishment}
                            setValue={setSenderRuralEstablishment}
                            onChange={handleSenderRuralEstablishmentSelection}
                            label="IE, Descrição"
                          />
                        </Grid>
                      </Grid>
                    </Card>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Body>
        </Container>
      </Fieldset>
    </>
  );
};

export default AccordionEmissaoRemetente;
